import { MappingVersion } from "../../api/versioningService";

export const canCreateNewVersion = (
  defaultVersion: Pick<MappingVersion, "isCalculated"> | null | undefined
): boolean => {
  if (!defaultVersion) return true;
  return defaultVersion.isCalculated;
};

export const isHistoricalVersionView = (
  versionIdParam: string | null,
  viewedVersion: Pick<MappingVersion, "isDefault"> | null | undefined
): boolean => {
  return !!versionIdParam && !!viewedVersion && !viewedVersion.isDefault;
};
